import { createSlice } from '@reduxjs/toolkit';

import { clearState } from './clearSlice';

// A card keeps its status until clicked, so it is stored per message,
// not looked up on every render.
const initialState = {
    byMsgId: {},
};

const contactCardSlice = createSlice({
    name: 'contactCards',
    initialState,
    reducers: {
        setContactCard(state, action) {
            const { msgId, card } = action.payload || {};
            if (msgId) state.byMsgId[msgId] = card;
        },
    },
    extraReducers: builder => {
        builder.addCase(clearState, () => initialState);
    },
});

export const { setContactCard } = contactCardSlice.actions;

export const selectContactCard = (state, msgId) => state.contactCards.byMsgId[msgId];

export default contactCardSlice.reducer;
